import { getDocument } from '@atlaskit/browser-apis';

export function resolveCurrentPageUrl(): string | undefined {
	try {
		const { origin, pathname } = window.location;

		const isLocal =
			origin.includes('localhost') || origin.includes('127.0.0.1') || origin.includes('0.0.0.0');

		if (isLocal) {
			const baseUrlMeta = getDocument()?.querySelector<HTMLMetaElement>(
				'meta[name="ajs-base-url"]',
			);
			if (baseUrlMeta?.content) {
				return baseUrlMeta.content + pathname;
			}

			const canonical = getDocument()?.querySelector<HTMLLinkElement>('link[rel="canonical"]');
			if (canonical?.href) {
				return canonical.href;
			}

			const siteUrl = (window as unknown as Record<string, unknown>).__SITE_URL__ as
				| string
				| undefined;
			if (siteUrl) {
				return siteUrl + pathname;
			}
		}

		return origin + pathname;
	} catch {
		return undefined;
	}
}
